export default __webpack_public_path__ + "static/media/Gold.3bd476cd.png";